var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sendMessageToTestBox } from "../messaging";
import { LOGIN_FAIL, LOGIN_SUCCESS } from "../messaging/outgoing";
import { error, info } from "./logging";
export let loggingIn = false;
export function autoLogin(data, router) {
    return __awaiter(this, void 0, void 0, function* () {
        let nextUrl;
        let errorMessage;
        loggingIn = true;
        try {
            const func = router["login"];
            if (!func) {
                info("No login callback exists!");
                sendMessageToTestBox(LOGIN_FAIL);
                return;
            }
            nextUrl = yield func(data);
        }
        catch (e) {
            error(e);
            errorMessage = e.message;
            nextUrl = false;
        }
        if (nextUrl === false) {
            sendMessageToTestBox(LOGIN_FAIL, { message: errorMessage });
        }
        else {
            sendMessageToTestBox(LOGIN_SUCCESS);
        }
        return nextUrl;
    });
}
